import {
  ContactAutofill,
  type Form,
} from '@wix/ambassador-forms-v4-form/types';
import { FIELD_TYPES, type UserData } from '@wix/form-fields';

import { type FormConfig, type FormValues } from '../../types';

const AUTOFILL_FIELDS: { fieldType: string; key: keyof UserData }[] = [
  { fieldType: FIELD_TYPES.CONTACTS_EMAIL, key: 'email' },
  { fieldType: FIELD_TYPES.CONTACTS_FIRST_NAME, key: 'firstName' },
  { fieldType: FIELD_TYPES.CONTACTS_LAST_NAME, key: 'lastName' },
  { fieldType: FIELD_TYPES.CONTACTS_PHONE, key: 'phone' },
];

export function autofillValues(
  form?: Form,
  values?: FormValues,
  config?: FormConfig | null,
): FormValues {
  const result = { ...values };
  const userData = config?.userData;
  if (!userData || form?.autoFillContact !== ContactAutofill.MEMBER_DATA) {
    return result;
  }

  const fields = form?.fields ?? [];

  for (const { fieldType, key } of AUTOFILL_FIELDS) {
    const value = userData[key]?.trim();
    if (!value) {
      continue;
    }
    const target = fields.find(
      (field) => field.view?.fieldType === fieldType,
    )?.target;
    if (target && (result[target] == null || result[target] === '')) {
      result[target] = value;
    }
  }

  return result;
}
